module.exports = __webpack_public_path__ + "schsafOne-3c0e84e9fefae221b690a913d4d5bbc2.png";